import { TEvent } from '@/types/events';
import { TSendListItem } from '@/types/sendList';
import { getDates } from '@/utils/getDates';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getSendList } from '../thunks/sendList';

export type TEventsState = {
    list: TSendListItem[]
    isLoading: boolean
    event: TEvent | undefined
}

const initialState: TEventsState = {
    isLoading: false,
    list: [],
    event: undefined,
};

export const sendListSlice = createSlice({
    name: 'sendList',
    initialState,
    reducers: {
        setSendListEvent: (state, action: PayloadAction<TEventsState['event']>) => {
            state.event = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getSendList.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getSendList.fulfilled, (state, action) => {
            state.list = action.payload.map((mail => ({
                ...mail,
                datestart: getDates(mail.datestart),
                datestop: getDates(mail.datestop),
            })));
            state.isLoading = false;
        });
        builder.addCase(getSendList.rejected, state => {
            state.isLoading = false;
        });
    },
});

export const { setSendListEvent } = sendListSlice.actions;
